module.exports = __webpack_public_path__ + "static/media/hero-interior.cdab4c9f.png";